<groundworks-card>
  <groundworks-card-header [title]="'Customer'" [action]="{ label: 'Deselect', click: onDeselect }" (actionButtonClick)="onDeselect()" />
  <groundworks-card-body>
    <div class="row g-3 mb-3">
      @switch (getState()) {
      @case ('loading') {
      <groundworks-state-message type="loading" message="Loading Opportunity..." class="d-flex" />
      }
      @case ('no-matches') {
      <groundworks-state-message type="no-matches" message="No Opportunity Found." class="d-flex" />
      }
      @case ('error') {
      <groundworks-state-message type="error" message="Error loading Opportunity." class="d-flex" />
      }
      @case ('matches') {
      @if (customerView(); as view) {
      <groundworks-customer-card [customerName]="view.customerName" [customerId]="view.customerId"
        [customerLabel]="'Customer Since'" [customerValue]="view.customerSince" [phone]="view.phone"
        [email]="view.email" [address]="view.address" [associatedContacts]="view.associatedContacts"
        [opportunities]="view.opportunities" [isSelectable]="false" [enableActivityPanel]="false"
        (addressClicked)="onAddressClick()" />
      }
      }
      }
    </div>
  </groundworks-card-body>
</groundworks-card>
